import { Pipe, PipeTransform } from '@angular/core';
import { translateOrganizationDiscountType } from '../mappers/enum-translation-mapper';
import { DiscountType } from '../enums/discount-type.enum';

@Pipe({
  name: 'translateOrganizationDiscountType',
})
export class TranslateOrganizationDiscountTypeEnum implements PipeTransform {
  transform(value: any): any {
    if (Array.isArray(value)) {
      value.forEach(element => {
        const enumElement = element as { name: string; index: number };
        enumElement.name = translateOrganizationDiscountType(enumElement.index as unknown as DiscountType);
      });
      return value;
    }
    return translateOrganizationDiscountType(value);
  }
}
